export const API_PREFIX = "/api/v0"

// Shared by the api client and the fetch layer, which mints guest sessions on
// its own (see ensureGuestSession)
export const GUEST_SIGNIN_PATH = `${API_PREFIX}/auth/guest`
